// extracted by mini-css-extract-plugin
module.exports = {"methodLabelsList":"MethodLabelsList_methodLabelsList__17_Hh"};